import { render, staticRenderFns } from "./ReportShiftTag.vue?vue&type=template&id=4de9a3d1"
import script from "./ReportShiftTag.vue?vue&type=script&lang=js"
export * from "./ReportShiftTag.vue?vue&type=script&lang=js"
import style0 from "./ReportShiftTag.vue?vue&type=style&index=0&id=4de9a3d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports